import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { SaleBudgetRequest } from "./sale-buget-req";

export class SaleBudgetResponseModel extends GlobalResponseObject{
    data?: SaleBudgetRequest[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SaleBudgetRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}